import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { QuantityGetDto } from 'svila-common';
import { Colors } from '~/src/scss/common/style';

interface ParamProps {
  item: QuantityGetDto;
}

export default function ProductBox({ item }: ParamProps): JSX.Element {

  return (
    <ProductWrapper>
      <Wrapper>
        <TitleSectionContainer>
          <StatusCheck>
          </StatusCheck>
          <TitleView>
          <StyledLink to={`/inventory/list-for-generic/${item.product.genericProduct.id}`}>{item.product.genericProduct.name} </StyledLink>
          </TitleView>
        </TitleSectionContainer>
        <TwoItems>
          <Table>
            <tbody>
              <tr>
                <td>Кашон</td>
                <td>{item.duGtin}</td>
                <td>{item.fullDuUnits}</td>
              </tr>
              <tr>
                <td>Дисплей</td>
                <td>{item.dpGtin}</td>
                <td>{item.singleDpUnits}</td>
              </tr>
              <tr>
                <td>Единица</td>
                <td>{item.cuGtin}</td>
                <td>{item.singleCuUnits}</td>
              </tr>
            </tbody>
          </Table>
        </TwoItems>
      </Wrapper>
    </ProductWrapper>
  );
}

const ProductWrapper = styled.div`
  margin-top: 10px;
`;

const Wrapper = styled.div`
  background: #eee;
  border-radius: 10px;
  margin-bottom: 10px;
  padding: 10px;
`;

const TitleSectionContainer = styled.div`
  margin-bottom: 10px;
  display: flex;
`;

const StatusCheck = styled.div`
  margin-bottom: 10px;
  width: 50px;
`;

const TitleView = styled.div`
  text-align: center;
  flex-grow: 1;
  padding: 0 10px;
`;

const TwoItems = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Table = styled.table`
  width: 100%;
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${Colors.darkBrown};
  font-weight: bold; 
  font-size: 18px;

 &:hover {
    text-decoration: none;
    color: black;
  }
`;
